import React from 'react';
import { Box } from '@mui/material';

const BrainSVG = ({ size = 'clamp(56px, 8vw, 96px)' }) => (
  <Box
    sx={{
      width: size,
      height: size,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}
  >
    <Box
      component="svg"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 362 361"
      sx={{
        opacity: 1,
        transform: 'rotate(180deg)',
        maxWidth: '100%',
        maxHeight: '100%'
      }}
    >
      <defs>
        <linearGradient id="onboardingBrainGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#415B7E" stopOpacity="1" />
          <stop offset="14%" stopColor="#2D476A" stopOpacity="1" />
          <stop offset="25%" stopColor="#4A4F81" stopOpacity="1" />
          <stop offset="38%" stopColor="#363B6D" stopOpacity="1" />
          <stop offset="50%" stopColor="#A83836" stopOpacity="1" />
          <stop offset="67%" stopColor="#BC4C4A" stopOpacity="1" />
          <stop offset="81%" stopColor="#E78460" stopOpacity="1" />
          <stop offset="92%" stopColor="#DC9844" stopOpacity="1" />
        </linearGradient>
      </defs>
      <path
        fill="none"
        stroke="url(#onboardingBrainGradient)"
        strokeWidth="1.5"
        strokeDasharray="1000"
        strokeDashoffset="1000"
        style={{
          animation: 'drawPath 5s ease-in-out forwards'
        }}
        className="brain-path"
        d="M 175.13,292.45
           C 175.55,288.97 178.60,286.50 181.93,286.92
             185.26,287.34 187.62,290.49 187.20,293.96
             186.78,297.43 183.73,299.91 180.40,299.49
             177.07,299.07 174.71,295.92 175.13,292.45 Z
           M 147.12,288.92
           C 147.54,285.45 150.59,282.98 153.92,283.40
             157.25,283.82 159.61,286.97 159.19,290.44
             158.77,293.91 155.72,296.39 152.39,295.97
             149.06,295.55 146.70,292.40 147.12,288.92 Z
           M 202.35,288.50
           C 202.77,285.03 205.82,282.56 209.15,282.98
             212.48,283.40 214.84,286.55 214.42,290.02
             214.00,293.49 210.95,295.97 207.62,295.55
             204.29,295.13 201.93,291.98 202.35,288.50 Z
           M 121.66,278.36
           C 122.08,274.89 125.13,272.42 128.46,272.84
             131.79,273.26 134.16,276.41 133.73,279.88
             133.31,283.35 130.26,285.83 126.93,285.41
             123.60,284.99 121.24,281.83 121.66,278.36 Z
           M 228.40,277.32
           C 228.82,273.85 231.86,271.38 235.20,271.80
             238.53,272.21 240.89,275.37 240.47,278.84
             240.04,282.31 237.00,284.78 233.67,284.37
             230.33,283.95 227.97,280.79 228.40,277.32 Z
           M 99.56,261.13
           C 99.98,257.66 103.03,255.19 106.36,255.60
             109.69,256.02 112.05,259.18 111.63,262.65
             111.21,266.12 108.16,268.59 104.83,268.17
             101.50,267.75 99.14,264.60 99.56,261.13 Z
           M 250.31,259.49
           C 250.73,256.02 253.78,253.55 257.11,253.97
             260.44,254.39 262.80,257.54 262.38,261.01
             261.96,264.48 258.91,266.96 255.58,266.54
             252.25,266.12 249.89,262.96 250.31,259.49 Z
           M 82.63,238.65
           C 83.05,235.18 86.09,232.71 89.43,233.13
             92.76,233.55 95.12,236.70 94.70,240.17
             94.27,243.64 91.23,246.11 87.90,245.70
             84.56,245.28 82.20,242.12 82.63,238.65 Z
           M 267.32,236.26
           C 267.74,232.79 270.78,230.31 274.12,230.73
             277.45,231.15 279.81,234.30 279.39,237.77
             278.96,241.24 275.92,243.72 272.59,243.30
             269.25,242.88 266.89,239.73 267.32,236.26 Z
           M 71.67,211.59
           C 72.09,208.12 75.14,205.65 78.47,206.07
             81.80,206.49 84.16,209.64 83.74,213.11
             83.32,216.58 80.27,219.05 76.94,218.63
             73.61,218.22 71.25,215.06 71.67,211.59 Z
           M 277.61,209.22
           C 278.03,205.75 281.08,203.28 284.41,203.70
             287.75,204.12 290.11,207.27 289.68,210.74
             289.26,214.21 286.22,216.69 282.88,216.27
             279.55,215.85 277.19,212.69 277.61,209.22 Z
           M 68.39,183.08
           C 68.81,179.61 71.86,177.14 75.19,177.56
             78.52,177.97 80.88,181.13 80.46,184.60
             80.04,188.07 76.99,190.54 73.66,190.12
             70.33,189.70 67.97,186.55 68.39,183.08 Z
           M 281.08,180.71
           C 281.50,177.24 284.55,174.77 287.88,175.19
             291.22,175.60 293.58,178.76 293.15,182.23
             292.73,185.70 289.69,188.17 286.35,187.75
             283.02,187.34 280.66,184.18 281.08,180.71 Z
           M 71.85,154.25
           C 72.27,150.78 75.32,148.31 78.65,148.72
             81.98,149.14 84.34,152.30 83.92,155.77
             83.50,159.24 80.45,161.71 77.12,161.29
             73.79,160.87 71.43,157.72 71.85,154.25 Z
           M 277.64,151.95
           C 278.06,148.48 281.10,146.01 284.44,146.43
             287.77,146.84 290.13,150.00 289.71,153.47
             289.29,156.94 286.24,159.41 282.91,158.99
             279.57,158.57 277.21,155.42 277.64,151.95 Z
           M 82.27,127.47
           C 82.69,124.00 85.74,121.53 89.07,121.95
             92.41,122.37 94.77,125.52 94.34,128.99
             93.92,132.46 90.88,134.94 87.54,134.52
             84.21,134.10 81.85,130.95 82.27,127.47 Z
           M 266.73,125.12
           C 267.15,121.65 270.19,119.18 273.53,119.60
             276.86,120.02 279.22,123.17 278.80,126.64
             278.38,130.11 275.33,132.59 272.00,132.17
             268.66,131.75 266.30,128.59 266.73,125.12 Z
           M 99.17,104.37
           C 99.59,100.90 102.63,98.43 105.97,98.85
             109.30,99.27 111.66,102.42 111.24,105.89
             110.81,109.36 107.77,111.84 104.44,111.42
             101.10,111.00 98.74,107.84 99.17,104.37 Z
           M 249.66,102.53
           C 250.09,99.06 253.13,96.58 256.47,97.00
             259.80,97.42 262.16,100.57 261.74,104.05
             261.31,107.52 258.27,109.99 254.94,109.57
             251.60,109.15 249.24,106.00 249.66,102.53 Z
           M 121.11,86.45
           C 121.54,82.98 124.58,80.50 127.91,80.92
             131.25,81.34 133.61,84.49 133.19,87.96
             132.76,91.43 129.72,93.91 126.38,93.49
             123.05,93.07 120.69,89.92 121.11,86.45 Z
           M 227.45,85.22
           C 227.87,81.75 230.92,79.27 234.25,79.69
             237.58,80.11 239.94,83.26 239.52,86.73
             239.10,90.20 236.05,92.68 232.72,92.26
             229.39,91.84 227.03,88.69 227.45,85.22 Z
           M 146.67,74.59
           C 147.09,71.12 150.14,68.65 153.47,69.06
             156.81,69.48 159.16,72.64 158.74,76.11
             158.32,79.58 155.28,82.05 151.94,81.63
             148.61,81.21 146.25,78.06 146.67,74.59 Z
           M 202.02,74.36
           C 202.44,70.89 205.48,68.41 208.82,68.83
             212.15,69.25 214.51,72.40 214.09,75.88
             213.66,79.35 210.62,81.82 207.29,81.40
             203.95,80.98 201.59,77.83 202.02,74.36 Z
           M 174.38,70.89
           C 174.80,67.41 177.84,64.94 181.18,65.36
             184.51,65.78 186.87,68.93 186.45,72.40
             186.03,75.87 182.98,78.35 179.65,77.93
             176.31,77.51 173.96,74.36 174.38,70.89 Z
           M 194.48,302.90
           C 198.53,302.94 201.77,306.27 201.72,310.33
             201.68,314.39 198.36,317.65 194.31,317.60
             190.26,317.56 187.01,314.23 187.06,310.17
             187.10,306.10 190.43,302.85 194.48,302.90 Z
           M 160.44,302.50
           C 164.49,302.55 167.73,305.88 167.69,309.94
             167.64,314.00 164.32,317.26 160.27,317.21
             156.22,317.17 152.97,313.84 153.02,309.77
             153.07,305.71 156.39,302.46 160.44,302.50 Z
           M 226.58,294.78
           C 230.63,294.82 233.87,298.16 233.83,302.22
             233.78,306.28 230.46,309.53 226.41,309.49
             222.36,309.44 219.11,306.11 219.16,302.05
             219.21,297.99 222.53,294.73 226.58,294.78 Z
           M 128.53,293.65
           C 132.58,293.70 135.83,297.03 135.78,301.09
             135.73,305.15 132.41,308.41 128.36,308.36
             124.31,308.31 121.07,304.98 121.11,300.92
             121.16,296.86 124.48,293.61 128.53,293.65 Z
           M 256.31,278.45
           C 260.36,278.50 263.61,281.83 263.56,285.89
             263.51,289.95 260.19,293.21 256.14,293.16
             252.09,293.12 248.85,289.78 248.89,285.72
             248.94,281.66 252.26,278.41 256.31,278.45 Z
           M 99.76,276.66
           C 103.81,276.70 107.06,280.03 107.01,284.09
             106.97,288.16 103.64,291.41 99.59,291.36
             95.54,291.32 92.30,287.99 92.35,283.93
             92.39,279.86 95.71,276.61 99.76,276.66 Z
           M 280.21,255.00
           C 284.26,255.05 287.51,258.38 287.46,262.44
             287.42,266.50 284.09,269.76 280.05,269.71
             275.99,269.66 272.75,266.33 272.79,262.27
             272.84,258.21 276.16,254.96 280.21,255.00 Z
           M 76.49,252.93
           C 80.54,252.98 83.79,256.31 83.74,260.37
             83.69,264.43 80.37,267.69 76.32,267.64
             72.27,267.59 69.03,264.26 69.07,260.20
             69.12,256.14 72.44,252.88 76.49,252.93 Z
           M 297.52,225.95
           C 301.57,225.99 304.82,229.32 304.77,233.39
             304.72,237.45 301.40,240.70 297.35,240.66
             293.30,240.61 290.06,237.28 290.10,233.22
             290.15,229.16 293.47,225.90 297.52,225.95 Z
           M 59.77,223.13
           C 63.83,223.18 67.07,226.51 67.02,230.57
             66.98,234.63 63.66,237.89 59.61,237.84
             55.56,237.79 52.31,234.46 52.36,230.40
             52.40,226.34 55.72,223.09 59.77,223.13 Z
           M 306.28,193.39
           C 310.33,193.44 313.58,196.77 313.53,200.83
             313.48,204.89 310.16,208.15 306.11,208.10
             302.06,208.05 298.82,204.72 298.86,200.66
             298.91,196.60 302.23,193.35 306.28,193.39 Z
           M 52.07,190.65
           C 56.12,190.70 59.37,194.03 59.32,198.09
             59.27,202.15 55.95,205.41 51.90,205.36
             47.85,205.31 44.61,201.98 44.65,197.92
             44.70,193.86 48.02,190.60 52.07,190.65 Z
           M 306.66,160.03
           C 310.71,160.07 313.96,163.40 313.91,167.46
             313.87,171.53 310.55,174.78 306.49,174.73
             302.44,174.69 299.20,171.36 299.25,167.30
             299.29,163.23 302.61,159.98 306.66,160.03 Z
           M 52.40,156.92
           C 56.45,156.96 59.69,160.29 59.65,164.36
             59.60,168.42 56.28,171.67 52.23,171.62
             48.18,171.58 44.93,168.25 44.98,164.19
             45.03,160.12 48.35,156.87 52.40,156.92 Z
           M 298.73,127.28
           C 302.78,127.33 306.02,130.66 305.98,134.72
             305.93,138.78 302.61,142.03 298.56,141.99
             294.51,141.94 291.26,138.61 291.31,134.55
             291.36,130.49 294.68,127.23 298.73,127.28 Z
           M 61.35,124.64
           C 65.40,124.69 68.64,128.02 68.60,132.08
             68.55,136.14 65.23,139.40 61.18,139.35
             57.13,139.31 53.88,135.97 53.93,131.91
             53.98,127.85 57.30,124.60 61.35,124.64 Z
           M 282.10,97.74
           C 286.15,97.79 289.40,101.12 289.35,105.18
             289.30,109.24 285.98,112.50 281.93,112.45
             277.88,112.41 274.64,109.07 274.68,105.01
             274.73,100.95 278.05,97.70 282.10,97.74 Z
           M 78.54,95.76
           C 82.59,95.81 85.83,99.14 85.78,103.20
             85.74,107.26 82.42,110.52 78.37,110.47
             74.32,110.42 71.07,107.09 71.12,103.03
             71.16,98.97 74.49,95.72 78.54,95.76 Z
           M 258.66,73.90
           C 262.71,73.95 265.95,77.28 265.91,81.34
             265.86,85.40 262.54,88.65 258.49,88.61
             254.44,88.56 251.19,85.23 251.24,81.17
             251.29,77.11 254.61,73.85 258.66,73.90 Z
           M 102.47,72.19
           C 106.52,72.24 109.76,75.57 109.71,79.63
             109.67,83.69 106.35,86.95 102.30,86.90
             98.25,86.85 95.00,83.52 95.05,79.46
             95.09,75.40 98.42,72.14 102.47,72.19 Z
           M 229.74,56.83
           C 233.79,56.87 237.04,60.21 236.99,64.27
             236.94,68.33 233.62,71.58 229.57,71.54
             225.52,71.49 222.28,68.16 222.33,64.10
             222.37,60.04 225.69,56.78 229.74,56.83 Z
           M 131.53,55.15
           C 135.58,55.20 138.82,58.53 138.77,62.59
             138.73,66.65 135.41,69.91 131.36,69.86
             127.31,69.82 124.06,66.49 124.11,62.42
             124.15,58.36 127.48,55.11 131.53,55.15 Z
           M 197.82,47.63
           C 201.87,47.68 205.12,51.01 205.07,55.07
             205.03,59.13 201.70,62.38 197.65,62.34
             193.60,62.29 190.36,58.96 190.41,54.90
             190.45,50.84 193.77,47.58 197.82,47.63 Z
           M 164.24,47.24
           C 168.29,47.29 171.54,50.62 171.49,54.68
             171.44,58.74 168.12,62.00 164.07,61.95
             160.02,61.91 156.77,58.58 156.82,54.51
             156.87,50.45 160.19,47.20 164.24,47.24 Z
           M 169.51,329.57
           C 170.16,324.90 174.45,321.64 179.08,322.29
             183.71,322.94 186.94,327.25 186.28,331.93
             185.63,336.60 181.34,339.86 176.71,339.21
             172.08,338.56 168.86,334.25 169.51,329.57 Z
           M 207.47,324.94
           C 208.13,320.27 212.41,317.01 217.05,317.66
             221.68,318.31 224.90,322.62 224.25,327.30
             223.59,331.97 219.31,335.23 214.68,334.58
             210.04,333.93 206.82,329.62 207.47,324.94 Z
           M 130.59,324.12
           C 131.24,319.45 135.53,316.19 140.16,316.84
             144.79,317.49 148.01,321.80 147.36,326.47
             146.71,331.14 142.42,334.40 137.79,333.75
             133.16,333.11 129.93,328.79 130.59,324.12 Z
           M 243.94,310.51
           C 244.60,305.84 248.89,302.58 253.52,303.23
             258.15,303.88 261.37,308.19 260.72,312.87
             260.06,317.54 255.78,320.80 251.14,320.15
             246.51,319.50 243.29,315.19 243.94,310.51 Z
           M 95.36,309.23
           C 96.01,304.56 100.30,301.30 104.93,301.95
             109.56,302.60 112.78,306.91 112.13,311.58
             111.47,316.26 107.19,319.52 102.56,318.87
             97.92,318.22 94.70,313.90 95.36,309.23 Z
           M 274.79,287.02
           C 275.44,282.35 279.73,279.09 284.36,279.74
             288.99,280.39 292.22,284.70 291.56,289.37
             290.91,294.04 286.62,297.30 281.99,296.65
             277.36,296.00 274.13,291.69 274.79,287.02 Z
           M 64.93,285.43
           C 65.58,280.76 69.87,277.50 74.50,278.15
             79.13,278.80 82.35,283.11 81.70,287.78
             81.04,292.45 76.76,295.71 72.13,295.06
             67.50,294.41 64.27,290.10 64.93,285.43 Z
           M 298.91,256.10
           C 299.56,251.43 303.85,248.17 308.48,248.82
             313.11,249.47 316.34,253.78 315.68,258.45
             315.03,263.12 310.74,266.38 306.11,265.73
             301.48,265.08 298.25,260.77 298.91,256.10 Z
           M 41.79,254.68
           C 42.44,250.01 46.73,246.75 51.36,247.40
             55.99,248.05 59.21,252.36 58.56,257.03
             57.90,261.70 53.62,264.96 48.99,264.32
             44.36,263.67 41.13,259.36 41.79,254.68 Z
           M 313.76,219.89
           C 314.41,215.22 318.70,211.96 323.33,212.61
             327.96,213.26 331.19,217.57 330.53,222.24
             329.88,226.91 325.59,230.17 320.96,229.53
             316.33,228.88 313.11,224.56 313.76,219.89 Z
           M 27.05,217.91
           C 27.71,213.23 31.99,209.97 36.62,210.62
             41.26,211.27 44.48,215.59 43.83,220.26
             43.17,224.93 38.89,228.19 34.25,227.54
             29.62,226.89 26.40,222.58 27.05,217.91 Z
           M 319.14,181.52
           C 319.79,176.85 324.08,173.59 328.71,174.24
             333.34,174.89 336.56,179.20 335.91,183.87
             335.26,188.54 330.97,191.80 326.34,191.15
             321.71,190.50 318.48,186.19 319.14,181.52 Z
           M 23.04,179.36
           C 23.69,174.69 27.98,171.43 32.61,172.08
             37.24,172.73 40.46,177.04 39.81,181.71
             39.15,186.39 34.87,189.64 30.24,189.00
             25.60,188.35 22.38,184.03 23.04,179.36 Z
           M 314.89,142.64
           C 315.55,137.97 319.83,134.71 324.47,135.36
             329.10,136.00 332.32,140.32 331.67,144.99
             331.01,149.66 326.73,152.92 322.09,152.27
             317.46,151.62 314.24,147.31 314.89,142.64 Z
           M 28.41,140.56
           C 29.06,135.89 33.35,132.63 37.98,133.28
             42.61,133.93 45.83,138.24 45.18,142.91
             44.52,147.58 40.24,150.84 35.61,150.19
             30.98,149.54 27.75,145.23 28.41,140.56 Z
           M 300.22,106.18
           C 300.88,101.50 305.16,98.24 309.80,98.89
             314.43,99.54 317.65,103.86 317.00,108.53
             316.34,113.20 312.06,116.46 307.42,115.81
             302.79,115.16 299.57,110.85 300.22,106.18 Z
           M 43.43,104.70
           C 44.09,100.03 48.37,96.77 53.00,97.42
             57.63,98.07 60.86,102.38 60.20,107.06
             59.55,111.73 55.26,114.99 50.63,114.34
             46.00,113.69 42.78,109.38 43.43,104.70 Z
           M 276.91,75.27
           C 277.56,70.60 281.85,67.34 286.48,67.98
             291.11,68.63 294.33,72.95 293.68,77.62
             293.03,82.29 288.74,85.55 284.11,84.90
             279.48,84.25 276.25,79.94 276.91,75.27 Z
           M 67.39,73.97
           C 68.04,69.30 72.33,66.04 76.96,66.69
             81.59,67.34 84.82,71.65 84.16,76.32
             83.51,80.99 79.22,84.25 74.59,83.60
             69.96,82.95 66.73,78.64 67.39,73.97 Z
           M 246.32,51.36
           C 246.97,46.68 251.26,43.42 255.89,44.07
             260.52,44.72 263.75,49.04 263.09,53.71
             262.44,58.38 258.15,61.64 253.52,60.99
             248.89,60.34 245.66,56.03 246.32,51.36 Z
           M 98.28,50.34
           C 98.94,45.67 103.22,42.41 107.85,43.06
             112.49,43.70 115.71,48.02 115.06,52.69
             114.40,57.36 110.12,60.62 105.48,59.97
             100.85,59.32 97.63,55.01 98.28,50.34 Z
           M 211.13,36.07
           C 211.78,31.40 216.07,28.14 220.70,28.79
             225.33,29.44 228.55,33.75 227.90,38.42
             227.24,43.09 222.96,46.35 218.33,45.70
             213.69,45.05 210.47,40.74 211.13,36.07 Z
           M 134.09,34.99
           C 134.74,30.32 139.03,27.06 143.66,27.71
             148.29,28.35 151.51,32.67 150.86,37.34
             150.20,42.01 145.92,45.27 141.29,44.62
             136.66,43.97 133.43,39.66 134.09,34.99 Z
           M 172.72,30.69
           C 173.38,26.02 177.66,22.76 182.29,23.40
             186.93,24.05 190.15,28.37 189.50,33.04
             188.84,37.71 184.55,40.97 179.92,40.32
             175.29,39.67 172.07,35.36 172.72,30.69 Z
           M 157.33,341.33
           C 162.78,341.33 167.19,345.74 167.19,351.17
             167.19,356.60 162.78,361.00 157.33,361.00
             151.89,361.00 147.47,356.60 147.47,351.17
             147.47,345.74 151.89,341.33 157.33,341.33 Z
           M 246.11,329.99
           C 251.56,329.99 255.97,334.39 255.97,339.82
             255.97,345.25 251.56,349.65 246.11,349.65
             240.67,349.65 236.25,345.25 236.25,339.82
             236.25,334.39 240.67,329.99 246.11,329.99 Z
           M 75.37,307.70
           C 80.82,307.70 85.23,312.11 85.23,317.54
             85.23,322.97 80.82,327.37 75.37,327.37
             69.93,327.37 65.51,322.97 65.51,317.54
             65.51,312.11 69.93,307.70 75.37,307.70 Z
           M 317.60,275.98
           C 323.04,275.98 327.46,280.39 327.46,285.82
             327.46,291.25 323.04,295.65 317.60,295.65
             312.15,295.65 307.74,291.25 307.74,285.82
             307.74,280.39 312.15,275.98 317.60,275.98 Z
           M 20.80,236.76
           C 26.24,236.76 30.66,241.16 30.66,246.59
             30.66,252.02 26.24,256.43 20.80,256.43
             15.35,256.43 10.94,252.02 10.94,246.59
             10.94,241.16 15.35,236.76 20.80,236.76 Z
           M 351.69,193.21
           C 357.13,193.21 361.54,197.62 361.54,203.05
             361.54,208.48 357.13,212.88 351.69,212.88
             346.24,212.88 341.82,208.48 341.82,203.05
             341.82,197.62 346.24,193.21 351.69,193.21 Z
           M 9.86,148.35
           C 15.30,148.35 19.72,152.75 19.72,158.18
             19.72,163.61 15.30,168.01 9.86,168.01
             4.41,168.01 0.00,163.61 0.00,158.18
             0.00,152.75 4.41,148.35 9.86,148.35 Z
           M 340.51,104.94
           C 345.95,104.94 350.37,109.34 350.37,114.77
             350.37,120.20 345.95,124.61 340.51,124.61
             335.06,124.61 330.65,120.20 330.65,114.77
             330.65,109.34 335.06,104.94 340.51,104.94 Z
           M 44.05,66.18
           C 49.49,66.18 53.91,70.59 53.91,76.02
             53.91,81.45 49.49,85.85 44.05,85.85
             38.60,85.85 34.19,81.45 34.19,76.02
             34.19,70.59 38.60,66.18 44.05,66.18 Z
           M 285.83,34.19
           C 291.27,34.19 295.69,38.59 295.69,44.02
             295.69,49.45 291.27,53.85 285.83,53.85
             280.38,53.85 275.97,49.45 275.97,44.02
             275.97,38.59 280.38,34.19 285.83,34.19 Z
           M 114.65,11.08
           C 120.09,11.08 124.51,15.48 124.51,20.91
             124.51,26.34 120.09,30.75 114.65,30.75
             109.20,30.75 104.79,26.34 104.79,20.91
             104.79,15.48 109.20,11.08 114.65,11.08 Z
           M 203.65,0.00
           C 209.09,0.00 213.51,4.40 213.51,9.83
             213.51,15.26 209.09,19.67 203.65,19.67
             198.20,19.67 193.79,15.26 193.79,9.83
             193.79,4.40 198.20,0.00 203.65,0.00 Z"
      />
      <path
        className="brain-fill"
        fill="url(#onboardingBrainGradient)"
        fillOpacity="0"
        d="M 175.13,292.45
           C 175.55,288.97 178.60,286.50 181.93,286.92
             185.26,287.34 187.62,290.49 187.20,293.96
             186.78,297.43 183.73,299.91 180.40,299.49
             177.07,299.07 174.71,295.92 175.13,292.45 Z
           M 147.12,288.92
           C 147.54,285.45 150.59,282.98 153.92,283.40
             157.25,283.82 159.61,286.97 159.19,290.44
             158.77,293.91 155.72,296.39 152.39,295.97
             149.06,295.55 146.70,292.40 147.12,288.92 Z
           M 202.35,288.50
           C 202.77,285.03 205.82,282.56 209.15,282.98
             212.48,283.40 214.84,286.55 214.42,290.02
             214.00,293.49 210.95,295.97 207.62,295.55
             204.29,295.13 201.93,291.98 202.35,288.50 Z
           M 121.66,278.36
           C 122.08,274.89 125.13,272.42 128.46,272.84
             131.79,273.26 134.16,276.41 133.73,279.88
             133.31,283.35 130.26,285.83 126.93,285.41
             123.60,284.99 121.24,281.83 121.66,278.36 Z
           M 228.40,277.32
           C 228.82,273.85 231.86,271.38 235.20,271.80
             238.53,272.21 240.89,275.37 240.47,278.84
             240.04,282.31 237.00,284.78 233.67,284.37
             230.33,283.95 227.97,280.79 228.40,277.32 Z
           M 99.56,261.13
           C 99.98,257.66 103.03,255.19 106.36,255.60
             109.69,256.02 112.05,259.18 111.63,262.65
             111.21,266.12 108.16,268.59 104.83,268.17
             101.50,267.75 99.14,264.60 99.56,261.13 Z
           M 250.31,259.49
           C 250.73,256.02 253.78,253.55 257.11,253.97
             260.44,254.39 262.80,257.54 262.38,261.01
             261.96,264.48 258.91,266.96 255.58,266.54
             252.25,266.12 249.89,262.96 250.31,259.49 Z
           M 82.63,238.65
           C 83.05,235.18 86.09,232.71 89.43,233.13
             92.76,233.55 95.12,236.70 94.70,240.17
             94.27,243.64 91.23,246.11 87.90,245.70
             84.56,245.28 82.20,242.12 82.63,238.65 Z
           M 267.32,236.26
           C 267.74,232.79 270.78,230.31 274.12,230.73
             277.45,231.15 279.81,234.30 279.39,237.77
             278.96,241.24 275.92,243.72 272.59,243.30
             269.25,242.88 266.89,239.73 267.32,236.26 Z
           M 71.67,211.59
           C 72.09,208.12 75.14,205.65 78.47,206.07
             81.80,206.49 84.16,209.64 83.74,213.11
             83.32,216.58 80.27,219.05 76.94,218.63
             73.61,218.22 71.25,215.06 71.67,211.59 Z
           M 277.61,209.22
           C 278.03,205.75 281.08,203.28 284.41,203.70
             287.75,204.12 290.11,207.27 289.68,210.74
             289.26,214.21 286.22,216.69 282.88,216.27
             279.55,215.85 277.19,212.69 277.61,209.22 Z
           M 68.39,183.08
           C 68.81,179.61 71.86,177.14 75.19,177.56
             78.52,177.97 80.88,181.13 80.46,184.60
             80.04,188.07 76.99,190.54 73.66,190.12
             70.33,189.70 67.97,186.55 68.39,183.08 Z
           M 281.08,180.71
           C 281.50,177.24 284.55,174.77 287.88,175.19
             291.22,175.60 293.58,178.76 293.15,182.23
             292.73,185.70 289.69,188.17 286.35,187.75
             283.02,187.34 280.66,184.18 281.08,180.71 Z
           M 71.85,154.25
           C 72.27,150.78 75.32,148.31 78.65,148.72
             81.98,149.14 84.34,152.30 83.92,155.77
             83.50,159.24 80.45,161.71 77.12,161.29
             73.79,160.87 71.43,157.72 71.85,154.25 Z
           M 277.64,151.95
           C 278.06,148.48 281.10,146.01 284.44,146.43
             287.77,146.84 290.13,150.00 289.71,153.47
             289.29,156.94 286.24,159.41 282.91,158.99
             279.57,158.57 277.21,155.42 277.64,151.95 Z
           M 82.27,127.47
           C 82.69,124.00 85.74,121.53 89.07,121.95
             92.41,122.37 94.77,125.52 94.34,128.99
             93.92,132.46 90.88,134.94 87.54,134.52
             84.21,134.10 81.85,130.95 82.27,127.47 Z
           M 266.73,125.12
           C 267.15,121.65 270.19,119.18 273.53,119.60
             276.86,120.02 279.22,123.17 278.80,126.64
             278.38,130.11 275.33,132.59 272.00,132.17
             268.66,131.75 266.30,128.59 266.73,125.12 Z
           M 99.17,104.37
           C 99.59,100.90 102.63,98.43 105.97,98.85
             109.30,99.27 111.66,102.42 111.24,105.89
             110.81,109.36 107.77,111.84 104.44,111.42
             101.10,111.00 98.74,107.84 99.17,104.37 Z
           M 249.66,102.53
           C 250.09,99.06 253.13,96.58 256.47,97.00
             259.80,97.42 262.16,100.57 261.74,104.05
             261.31,107.52 258.27,109.99 254.94,109.57
             251.60,109.15 249.24,106.00 249.66,102.53 Z
           M 121.11,86.45
           C 121.54,82.98 124.58,80.50 127.91,80.92
             131.25,81.34 133.61,84.49 133.19,87.96
             132.76,91.43 129.72,93.91 126.38,93.49
             123.05,93.07 120.69,89.92 121.11,86.45 Z
           M 227.45,85.22
           C 227.87,81.75 230.92,79.27 234.25,79.69
             237.58,80.11 239.94,83.26 239.52,86.73
             239.10,90.20 236.05,92.68 232.72,92.26
             229.39,91.84 227.03,88.69 227.45,85.22 Z
           M 146.67,74.59
           C 147.09,71.12 150.14,68.65 153.47,69.06
             156.81,69.48 159.16,72.64 158.74,76.11
             158.32,79.58 155.28,82.05 151.94,81.63
             148.61,81.21 146.25,78.06 146.67,74.59 Z
           M 202.02,74.36
           C 202.44,70.89 205.48,68.41 208.82,68.83
             212.15,69.25 214.51,72.40 214.09,75.88
             213.66,79.35 210.62,81.82 207.29,81.40
             203.95,80.98 201.59,77.83 202.02,74.36 Z
           M 174.38,70.89
           C 174.80,67.41 177.84,64.94 181.18,65.36
             184.51,65.78 186.87,68.93 186.45,72.40
             186.03,75.87 182.98,78.35 179.65,77.93
             176.31,77.51 173.96,74.36 174.38,70.89 Z
           M 194.48,302.90
           C 198.53,302.94 201.77,306.27 201.72,310.33
             201.68,314.39 198.36,317.65 194.31,317.60
             190.26,317.56 187.01,314.23 187.06,310.17
             187.10,306.10 190.43,302.85 194.48,302.90 Z
           M 160.44,302.50
           C 164.49,302.55 167.73,305.88 167.69,309.94
             167.64,314.00 164.32,317.26 160.27,317.21
             156.22,317.17 152.97,313.84 153.02,309.77
             153.07,305.71 156.39,302.46 160.44,302.50 Z
           M 226.58,294.78
           C 230.63,294.82 233.87,298.16 233.83,302.22
             233.78,306.28 230.46,309.53 226.41,309.49
             222.36,309.44 219.11,306.11 219.16,302.05
             219.21,297.99 222.53,294.73 226.58,294.78 Z
           M 128.53,293.65
           C 132.58,293.70 135.83,297.03 135.78,301.09
             135.73,305.15 132.41,308.41 128.36,308.36
             124.31,308.31 121.07,304.98 121.11,300.92
             121.16,296.86 124.48,293.61 128.53,293.65 Z
           M 256.31,278.45
           C 260.36,278.50 263.61,281.83 263.56,285.89
             263.51,289.95 260.19,293.21 256.14,293.16
             252.09,293.12 248.85,289.78 248.89,285.72
             248.94,281.66 252.26,278.41 256.31,278.45 Z
           M 99.76,276.66
           C 103.81,276.70 107.06,280.03 107.01,284.09
             106.97,288.16 103.64,291.41 99.59,291.36
             95.54,291.32 92.30,287.99 92.35,283.93
             92.39,279.86 95.71,276.61 99.76,276.66 Z
           M 280.21,255.00
           C 284.26,255.05 287.51,258.38 287.46,262.44
             287.42,266.50 284.09,269.76 280.05,269.71
             275.99,269.66 272.75,266.33 272.79,262.27
             272.84,258.21 276.16,254.96 280.21,255.00 Z
           M 76.49,252.93
           C 80.54,252.98 83.79,256.31 83.74,260.37
             83.69,264.43 80.37,267.69 76.32,267.64
             72.27,267.59 69.03,264.26 69.07,260.20
             69.12,256.14 72.44,252.88 76.49,252.93 Z
           M 297.52,225.95
           C 301.57,225.99 304.82,229.32 304.77,233.39
             304.72,237.45 301.40,240.70 297.35,240.66
             293.30,240.61 290.06,237.28 290.10,233.22
             290.15,229.16 293.47,225.90 297.52,225.95 Z
           M 59.77,223.13
           C 63.83,223.18 67.07,226.51 67.02,230.57
             66.98,234.63 63.66,237.89 59.61,237.84
             55.56,237.79 52.31,234.46 52.36,230.40
             52.40,226.34 55.72,223.09 59.77,223.13 Z
           M 306.28,193.39
           C 310.33,193.44 313.58,196.77 313.53,200.83
             313.48,204.89 310.16,208.15 306.11,208.10
             302.06,208.05 298.82,204.72 298.86,200.66
             298.91,196.60 302.23,193.35 306.28,193.39 Z
           M 52.07,190.65
           C 56.12,190.70 59.37,194.03 59.32,198.09
             59.27,202.15 55.95,205.41 51.90,205.36
             47.85,205.31 44.61,201.98 44.65,197.92
             44.70,193.86 48.02,190.60 52.07,190.65 Z
           M 306.66,160.03
           C 310.71,160.07 313.96,163.40 313.91,167.46
             313.87,171.53 310.55,174.78 306.49,174.73
             302.44,174.69 299.20,171.36 299.25,167.30
             299.29,163.23 302.61,159.98 306.66,160.03 Z
           M 52.40,156.92
           C 56.45,156.96 59.69,160.29 59.65,164.36
             59.60,168.42 56.28,171.67 52.23,171.62
             48.18,171.58 44.93,168.25 44.98,164.19
             45.03,160.12 48.35,156.87 52.40,156.92 Z
           M 298.73,127.28
           C 302.78,127.33 306.02,130.66 305.98,134.72
             305.93,138.78 302.61,142.03 298.56,141.99
             294.51,141.94 291.26,138.61 291.31,134.55
             291.36,130.49 294.68,127.23 298.73,127.28 Z
           M 61.35,124.64
           C 65.40,124.69 68.64,128.02 68.60,132.08
             68.55,136.14 65.23,139.40 61.18,139.35
             57.13,139.31 53.88,135.97 53.93,131.91
             53.98,127.85 57.30,124.60 61.35,124.64 Z
           M 282.10,97.74
           C 286.15,97.79 289.40,101.12 289.35,105.18
             289.30,109.24 285.98,112.50 281.93,112.45
             277.88,112.41 274.64,109.07 274.68,105.01
             274.73,100.95 278.05,97.70 282.10,97.74 Z
           M 78.54,95.76
           C 82.59,95.81 85.83,99.14 85.78,103.20
             85.74,107.26 82.42,110.52 78.37,110.47
             74.32,110.42 71.07,107.09 71.12,103.03
             71.16,98.97 74.49,95.72 78.54,95.76 Z
           M 258.66,73.90
           C 262.71,73.95 265.95,77.28 265.91,81.34
             265.86,85.40 262.54,88.65 258.49,88.61
             254.44,88.56 251.19,85.23 251.24,81.17
             251.29,77.11 254.61,73.85 258.66,73.90 Z
           M 102.47,72.19
           C 106.52,72.24 109.76,75.57 109.71,79.63
             109.67,83.69 106.35,86.95 102.30,86.90
             98.25,86.85 95.00,83.52 95.05,79.46
             95.09,75.40 98.42,72.14 102.47,72.19 Z
           M 229.74,56.83
           C 233.79,56.87 237.04,60.21 236.99,64.27
             236.94,68.33 233.62,71.58 229.57,71.54
             225.52,71.49 222.28,68.16 222.33,64.10
             222.37,60.04 225.69,56.78 229.74,56.83 Z
           M 131.53,55.15
           C 135.58,55.20 138.82,58.53 138.77,62.59
             138.73,66.65 135.41,69.91 131.36,69.86
             127.31,69.82 124.06,66.49 124.11,62.42
             124.15,58.36 127.48,55.11 131.53,55.15 Z
           M 197.82,47.63
           C 201.87,47.68 205.12,51.01 205.07,55.07
             205.03,59.13 201.70,62.38 197.65,62.34
             193.60,62.29 190.36,58.96 190.41,54.90
             190.45,50.84 193.77,47.58 197.82,47.63 Z
           M 164.24,47.24
           C 168.29,47.29 171.54,50.62 171.49,54.68
             171.44,58.74 168.12,62.00 164.07,61.95
             160.02,61.91 156.77,58.58 156.82,54.51
             156.87,50.45 160.19,47.20 164.24,47.24 Z
           M 169.51,329.57
           C 170.16,324.90 174.45,321.64 179.08,322.29
             183.71,322.94 186.94,327.25 186.28,331.93
             185.63,336.60 181.34,339.86 176.71,339.21
             172.08,338.56 168.86,334.25 169.51,329.57 Z
           M 207.47,324.94
           C 208.13,320.27 212.41,317.01 217.05,317.66
             221.68,318.31 224.90,322.62 224.25,327.30
             223.59,331.97 219.31,335.23 214.68,334.58
             210.04,333.93 206.82,329.62 207.47,324.94 Z
           M 130.59,324.12
           C 131.24,319.45 135.53,316.19 140.16,316.84
             144.79,317.49 148.01,321.80 147.36,326.47
             146.71,331.14 142.42,334.40 137.79,333.75
             133.16,333.11 129.93,328.79 130.59,324.12 Z
           M 243.94,310.51
           C 244.60,305.84 248.89,302.58 253.52,303.23
             258.15,303.88 261.37,308.19 260.72,312.87
             260.06,317.54 255.78,320.80 251.14,320.15
             246.51,319.50 243.29,315.19 243.94,310.51 Z
           M 95.36,309.23
           C 96.01,304.56 100.30,301.30 104.93,301.95
             109.56,302.60 112.78,306.91 112.13,311.58
             111.47,316.26 107.19,319.52 102.56,318.87
             97.92,318.22 94.70,313.90 95.36,309.23 Z
           M 274.79,287.02
           C 275.44,282.35 279.73,279.09 284.36,279.74
             288.99,280.39 292.22,284.70 291.56,289.37
             290.91,294.04 286.62,297.30 281.99,296.65
             277.36,296.00 274.13,291.69 274.79,287.02 Z
           M 64.93,285.43
           C 65.58,280.76 69.87,277.50 74.50,278.15
             79.13,278.80 82.35,283.11 81.70,287.78
             81.04,292.45 76.76,295.71 72.13,295.06
             67.50,294.41 64.27,290.10 64.93,285.43 Z
           M 298.91,256.10
           C 299.56,251.43 303.85,248.17 308.48,248.82
             313.11,249.47 316.34,253.78 315.68,258.45
             315.03,263.12 310.74,266.38 306.11,265.73
             301.48,265.08 298.25,260.77 298.91,256.10 Z
           M 41.79,254.68
           C 42.44,250.01 46.73,246.75 51.36,247.40
             55.99,248.05 59.21,252.36 58.56,257.03
             57.90,261.70 53.62,264.96 48.99,264.32
             44.36,263.67 41.13,259.36 41.79,254.68 Z
           M 313.76,219.89
           C 314.41,215.22 318.70,211.96 323.33,212.61
             327.96,213.26 331.19,217.57 330.53,222.24
             329.88,226.91 325.59,230.17 320.96,229.53
             316.33,228.88 313.11,224.56 313.76,219.89 Z
           M 27.05,217.91
           C 27.71,213.23 31.99,209.97 36.62,210.62
             41.26,211.27 44.48,215.59 43.83,220.26
             43.17,224.93 38.89,228.19 34.25,227.54
             29.62,226.89 26.40,222.58 27.05,217.91 Z
           M 319.14,181.52
           C 319.79,176.85 324.08,173.59 328.71,174.24
             333.34,174.89 336.56,179.20 335.91,183.87
             335.26,188.54 330.97,191.80 326.34,191.15
             321.71,190.50 318.48,186.19 319.14,181.52 Z
           M 23.04,179.36
           C 23.69,174.69 27.98,171.43 32.61,172.08
             37.24,172.73 40.46,177.04 39.81,181.71
             39.15,186.39 34.87,189.64 30.24,189.00
             25.60,188.35 22.38,184.03 23.04,179.36 Z
           M 314.89,142.64
           C 315.55,137.97 319.83,134.71 324.47,135.36
             329.10,136.00 332.32,140.32 331.67,144.99
             331.01,149.66 326.73,152.92 322.09,152.27
             317.46,151.62 314.24,147.31 314.89,142.64 Z
           M 28.41,140.56
           C 29.06,135.89 33.35,132.63 37.98,133.28
             42.61,133.93 45.83,138.24 45.18,142.91
             44.52,147.58 40.24,150.84 35.61,150.19
             30.98,149.54 27.75,145.23 28.41,140.56 Z
           M 300.22,106.18
           C 300.88,101.50 305.16,98.24 309.80,98.89
             314.43,99.54 317.65,103.86 317.00,108.53
             316.34,113.20 312.06,116.46 307.42,115.81
             302.79,115.16 299.57,110.85 300.22,106.18 Z
           M 43.43,104.70
           C 44.09,100.03 48.37,96.77 53.00,97.42
             57.63,98.07 60.86,102.38 60.20,107.06
             59.55,111.73 55.26,114.99 50.63,114.34
             46.00,113.69 42.78,109.38 43.43,104.70 Z
           M 276.91,75.27
           C 277.56,70.60 281.85,67.34 286.48,67.98
             291.11,68.63 294.33,72.95 293.68,77.62
             293.03,82.29 288.74,85.55 284.11,84.90
             279.48,84.25 276.25,79.94 276.91,75.27 Z
           M 67.39,73.97
           C 68.04,69.30 72.33,66.04 76.96,66.69
             81.59,67.34 84.82,71.65 84.16,76.32
             83.51,80.99 79.22,84.25 74.59,83.60
             69.96,82.95 66.73,78.64 67.39,73.97 Z
           M 246.32,51.36
           C 246.97,46.68 251.26,43.42 255.89,44.07
             260.52,44.72 263.75,49.04 263.09,53.71
             262.44,58.38 258.15,61.64 253.52,60.99
             248.89,60.34 245.66,56.03 246.32,51.36 Z
           M 98.28,50.34
           C 98.94,45.67 103.22,42.41 107.85,43.06
             112.49,43.70 115.71,48.02 115.06,52.69
             114.40,57.36 110.12,60.62 105.48,59.97
             100.85,59.32 97.63,55.01 98.28,50.34 Z
           M 211.13,36.07
           C 211.78,31.40 216.07,28.14 220.70,28.79
             225.33,29.44 228.55,33.75 227.90,38.42
             227.24,43.09 222.96,46.35 218.33,45.70
             213.69,45.05 210.47,40.74 211.13,36.07 Z
           M 134.09,34.99
           C 134.74,30.32 139.03,27.06 143.66,27.71
             148.29,28.35 151.51,32.67 150.86,37.34
             150.20,42.01 145.92,45.27 141.29,44.62
             136.66,43.97 133.43,39.66 134.09,34.99 Z
           M 172.72,30.69
           C 173.38,26.02 177.66,22.76 182.29,23.40
             186.93,24.05 190.15,28.37 189.50,33.04
             188.84,37.71 184.55,40.97 179.92,40.32
             175.29,39.67 172.07,35.36 172.72,30.69 Z
           M 157.33,341.33
           C 162.78,341.33 167.19,345.74 167.19,351.17
             167.19,356.60 162.78,361.00 157.33,361.00
             151.89,361.00 147.47,356.60 147.47,351.17
             147.47,345.74 151.89,341.33 157.33,341.33 Z
           M 246.11,329.99
           C 251.56,329.99 255.97,334.39 255.97,339.82
             255.97,345.25 251.56,349.65 246.11,349.65
             240.67,349.65 236.25,345.25 236.25,339.82
             236.25,334.39 240.67,329.99 246.11,329.99 Z
           M 75.37,307.70
           C 80.82,307.70 85.23,312.11 85.23,317.54
             85.23,322.97 80.82,327.37 75.37,327.37
             69.93,327.37 65.51,322.97 65.51,317.54
             65.51,312.11 69.93,307.70 75.37,307.70 Z
           M 317.60,275.98
           C 323.04,275.98 327.46,280.39 327.46,285.82
             327.46,291.25 323.04,295.65 317.60,295.65
             312.15,295.65 307.74,291.25 307.74,285.82
             307.74,280.39 312.15,275.98 317.60,275.98 Z
           M 20.80,236.76
           C 26.24,236.76 30.66,241.16 30.66,246.59
             30.66,252.02 26.24,256.43 20.80,256.43
             15.35,256.43 10.94,252.02 10.94,246.59
             10.94,241.16 15.35,236.76 20.80,236.76 Z
           M 351.69,193.21
           C 357.13,193.21 361.54,197.62 361.54,203.05
             361.54,208.48 357.13,212.88 351.69,212.88
             346.24,212.88 341.82,208.48 341.82,203.05
             341.82,197.62 346.24,193.21 351.69,193.21 Z
           M 9.86,148.35
           C 15.30,148.35 19.72,152.75 19.72,158.18
             19.72,163.61 15.30,168.01 9.86,168.01
             4.41,168.01 0.00,163.61 0.00,158.18
             0.00,152.75 4.41,148.35 9.86,148.35 Z
           M 340.51,104.94
           C 345.95,104.94 350.37,109.34 350.37,114.77
             350.37,120.20 345.95,124.61 340.51,124.61
             335.06,124.61 330.65,120.20 330.65,114.77
             330.65,109.34 335.06,104.94 340.51,104.94 Z
           M 44.05,66.18
           C 49.49,66.18 53.91,70.59 53.91,76.02
             53.91,81.45 49.49,85.85 44.05,85.85
             38.60,85.85 34.19,81.45 34.19,76.02
             34.19,70.59 38.60,66.18 44.05,66.18 Z
           M 285.83,34.19
           C 291.27,34.19 295.69,38.59 295.69,44.02
             295.69,49.45 291.27,53.85 285.83,53.85
             280.38,53.85 275.97,49.45 275.97,44.02
             275.97,38.59 280.38,34.19 285.83,34.19 Z
           M 114.65,11.08
           C 120.09,11.08 124.51,15.48 124.51,20.91
             124.51,26.34 120.09,30.75 114.65,30.75
             109.20,30.75 104.79,26.34 104.79,20.91
             104.79,15.48 109.20,11.08 114.65,11.08 Z
           M 203.65,0.00
           C 209.09,0.00 213.51,4.40 213.51,9.83
             213.51,15.26 209.09,19.67 203.65,19.67
             198.20,19.67 193.79,15.26 193.79,9.83
             193.79,4.40 198.20,0.00 203.65,0.00 Z"
      />

      <style>{`
        @keyframes drawPath {
          0% {
            stroke-dashoffset: 1000;
          }
          10% {
            stroke-dashoffset: 1000;
          }
          100% {
            stroke-dashoffset: 0;
          }
        }

        @keyframes fillBrain {
          0% {
            fill-opacity: 0;
          }
          100% {
            fill-opacity: 1;
          }
        }

        .brain-fill {
          animation: fillBrain 1.5s ease-in-out forwards;
          animation-delay: 1s;
        }
      `}</style>
    </Box>
  </Box>
);

export default BrainSVG;
